// Taken From:
// https://stackoverflow.com/questions/849211/shortest-distance-between-a-point-and-a-line-segment

function sqr(x) {
  return x * x
}

function dist2(v, w) {
  return sqr(v[0] - w[0]) + sqr(v[1] - w[1])
}

// p - point
// v - start point of segment
// w - end point of segment
function distToSegmentSquared(p, v, w) {
  var l2 = dist2(v, w)
  if (l2 === 0) return dist2(p, v)
  var t = ((p[0] - v[0]) * (w[0] - v[0]) + (p[1] - v[1]) * (w[1] - v[1])) / l2
  t = Math.max(0, Math.min(1, t))
  return dist2(p, [v[0] + t * (w[0] - v[0]), v[1] + t * (w[1] - v[1])])
}

// p - point
// v - start point of segment
// w - end point of segment
export function distToLine(p, v, w) {
  return Math.sqrt(distToSegmentSquared(p, v, w))
}

export function distToRect(p, v, w) {
  const [x1, y1] = v
  const [x2, y2] = w
  return Math.min(
    ...[
      Math.sqrt(distToSegmentSquared(p, [x1, y1], [x1, y2])),
      Math.sqrt(distToSegmentSquared(p, [x1, y1], [x2, y1])),
      Math.sqrt(distToSegmentSquared(p, [x2, y1], [x2, y2])),
      Math.sqrt(distToSegmentSquared(p, [x1, y2], [x2, y2])),
    ],
  )
}

export function destroy(container) {
  if (container.children.length > 0) {
    container.removeChildren().forEach(i => destroy(i))
  }
  container.destroy(true)
}

export function clear(container) {
  container.removeChildren().forEach(i => destroy(i))
}
